import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useLocation } from '@reach/router';
import { useStaticQuery, graphql } from "gatsby";

const SEO = ({ title, description, img }) => {

    const { pathname } = useLocation();
    const { site, ogImg } = useStaticQuery(query);
    const {
        defaultTitle,
        defaultDescription,
        titleExtension,
        siteUrl,
    } = site.siteMetadata


    const seo = {
        title: `${title} | ${titleExtension}` || defaultTitle,
        description: description || defaultDescription,
        url: `${siteUrl}${pathname}`,
        baseUrl: siteUrl,
        image: img || ogImg.publicURL
    }


    return (
        <>
            <Helmet title={seo.title} titleTemplate={`%s | ` + defaultTitle}>
                {seo.url && (<meta property="og:url" content={seo.url} />)}

                {seo.title && <meta property="og:title" content={seo.title} />}
                {seo.title && <meta property="twitter:title" content={seo.title} />}

                {seo.description && <meta name="description" content={seo.description} />}
                {seo.description && <meta name="twitter:description" content={seo.description} />}
                {seo.description && <meta name="og:description" content={seo.description} />}

                {seo.image && <meta property="twitter:img:src" content={seo.baseUrl + seo.image} />}
                {seo.image && <meta property="og:image" content={seo.baseUrl + seo.image} />}
                <meta name="facebook-domain-verification" content="y4zg3wr1nomd74u0g358m3teljx17s" />


                <link rel="icon" type="image/png" href="/favicon.png" />
            </Helmet>
        </>
    )

}

export default SEO;

SEO.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired
}

SEO.defaultProps = {
    title: null,
    description: null
}


const query = graphql`
  query SEO {
        site {
            siteMetadata {
            defaultTitle: title
            defaultDescription: description
            titleExtension
            siteUrl: url
            }
        }
    ogImg: file(relativePath: {eq: "index-hero.jpg"}) {
        publicURL
    }
  }
`